export default __webpack_public_path__ + "static/media/kefutime.144e0346.png";